import React from 'react';

import { sessionStorageUtils } from '../../../utils/session-storage-utils';

/**
 * Hook that preserves text in search during the user session.
 */
export const useProjectSearchFilter = () => {
  const [searchText, setSearchText] = React.useState(
    sessionStorageUtils.getUserItemOrDefault('projectListSearchText', ''),
  );

  React.useEffect(() => {
    sessionStorageUtils.setUserItem('projectListSearchText', searchText);
  }, [searchText]);

  return { searchText, setSearchText };
};
